var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled } from '@mui/system';
import { Box } from '@mui/material';
export var LoaderBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    text-align: center;\n"], ["\n    text-align: center;\n"])));
var templateObject_1;
